import styles from './ApiTokensTab.module.scss';
import ApiTokensList from './components/apiTokensList/ApiTokensList';

const ApiTokensTab = () => {    
    return <div className={styles.container}>    
        <ApiTokensList />
    </div>;
}

export default ApiTokensTab;
